import cx from 'classnames'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import Styles from './BrandWizardVisualAnalysisModal.module.scss'
import { useHover } from '@react-aria/interactions'
import { HexColorPicker } from 'react-colorful'
import { useState } from 'react'
import { Button } from 'blaze-ui/Button'
import { Edit1 } from 'blaze-ui/icons'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { HexColorInput } from 'components/HexColorInput/HexColorInput'

interface Props {
  color: string
  onChange: (color: string) => void
}

interface ColorPickerProps {
  value: string
  onChange: (color: string) => void
}

const ColorPicker = ({ value, onChange }: ColorPickerProps) => {
  return (
    <div className={Styles.colorPicker}>
      <HexColorPicker color={value} onChange={(hex: string) => onChange(hex)} />
      <HexColorInput
        aria-label="Hex Value"
        autoFocus
        color={value}
        onChange={(value) => onChange(value)}
        name="hex"
        maxLength={7}
      />
    </div>
  )
}

export const Color = ({ color, onChange }: Props) => {
  const [isEditing, setIsEditing] = useState(false)
  const { isHovered, hoverProps } = useHover({})
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.color} style={{ backgroundColor: color }} {...hoverProps} aria-label={`Color: ${color}`}>
      <div className={cx(Styles.button, { [Styles.visible]: isHovered || isEditing || isMobile })}>
        <DropdownTrigger onOpenChange={setIsEditing} popoverClassName={Styles.colorPickerPopover}>
          <Button variant="secondary" size="xs" frontIcon={Edit1}>
            {isMobile ? '' : 'Change'}
          </Button>
          {() => <ColorPicker value={color} onChange={onChange} />}
        </DropdownTrigger>
      </div>
    </div>
  )
}
